var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      ref: "date_input",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "date_input" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "date_input_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c(
            "a",
            {
              attrs: { href: "#", id: "date_input_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("date_input")
                },
              },
            },
            [_c("i", { staticClass: "fas fa-arrow-left" })]
          ),
          _c("h4", { staticClass: "font-weight-bold m-0 title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ]),
          _c("h4", { staticClass: "font-weight-bold m-0 mobile-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("dateInput.mobileTitle")) + " "),
          ]),
          _c("div"),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "85vh", position: "relative" },
        },
        [
          _c("b-calendar", {
            ref: "smallCalendar",
            attrs: {
              "hide-header": true,
              "today-variant": "success",
              locale: _vm.locale,
              "date-disabled-fn": _vm.dateDisabled,
              "start-weekday": 1,
              "value-as-date": true,
            },
            on: { context: _vm.onContext, selected: _vm.dateSelected },
            scopedSlots: _vm._u([
              {
                key: "nav-prev-month",
                fn: function () {
                  return [
                    _c("i", {
                      staticClass: "la la-arrow-left b-calendar-custom-nav",
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "nav-next-month",
                fn: function () {
                  return [
                    _c("i", {
                      staticClass: "la la-arrow-right b-calendar-custom-nav",
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "nav-this-month",
                fn: function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "b-calendar-month-string",
                        staticStyle: { "margin-right": "5px" },
                      },
                      [_vm._v(_vm._s(_vm.monthString))]
                    ),
                    _c("span", { staticClass: "b-calendar-year-string" }, [
                      _vm._v(_vm._s(_vm.yearString)),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.selectedDate,
              callback: function ($$v) {
                _vm.selectedDate = $$v
              },
              expression: "selectedDate",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _c(
          "button",
          {
            staticClass: "bb-btn btn-success save-btn",
            on: { click: _vm.save },
          },
          [_vm._v(" " + _vm._s(_vm.$t("dateInput.saveBtn")) + " ")]
        ),
        _c("div", { staticClass: "mobile-calendar-navigation" }, [
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  return _vm.navigateSmallCalendar("prev")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-arrow-left",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "19", y1: "12", x2: "5", y2: "12" },
                  }),
                  _c("polyline", { attrs: { points: "12 19 5 12 12 5" } }),
                ]
              ),
            ]
          ),
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  return _vm.navigateSmallCalendar("next")
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-arrow-right",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "5", y1: "12", x2: "19", y2: "12" },
                  }),
                  _c("polyline", { attrs: { points: "12 5 19 12 12 19" } }),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }